export const HTTP_STATUS_CODES = {
    SUCCESS: 200,
    CREATED: 201,
    NOT_FOUND: 404,
    VALIDATION_ERROR: 400,
    SERVER_ERROR: 500,
    CACHED_RESPONSE: 700,
    UN_AUTHORIZED: 401,
};

export const httpApiUrl =
    process.env.NEXT_PUBLIC_BYPASS_CORS === 'true'
        ? '/api'
        : process.env.NEXT_PUBLIC_API_HTTP_URL || 'https://api.qlub.cloud';

export const wsApiUrl: string = process.env.NEXT_PUBLIC_API_WS_URL || '';

export const socketUrl = process.env.NEXT_PUBLIC_MENU_SOCKET_URL || '';

export const gaToken: string = process.env.NEXT_PUBLIC_GA_TOKEN || '';

export const recaptchaSiteKey: string = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || '';

export const recaptchaEnable: boolean = (process.env.NEXT_PUBLIC_RECAPTCHA_ENABLE || '') === 'true';

export const appVersion = process.env.NEXT_PUBLIC_APP_VERSION || '';

export const cdnDomain = process.env.NEXT_PUBLIC_CDN_DOMAIN || '';

export const saHttpApiUrl =
    process.env.NEXT_PUBLIC_BYPASS_CORS === 'true' ? '/api' : process.env.NEXT_PUBLIC_SA_API_HTTP_URL || '';

export const saWsApiUrl: string = process.env.NEXT_PUBLIC_SA_API_WS_URL || '';

export const saSocketUrl = process.env.NEXT_PUBLIC_SA_MENU_SOCKET_URL || '';

interface IBaseUrl {
    http: string;
    ws: string;
    socket: string;
}

export const baseUrlMap: Record<string, IBaseUrl> = {
    default: {
        http: httpApiUrl,
        ws: wsApiUrl,
        socket: socketUrl,
    },
    sa: {
        http: saHttpApiUrl || httpApiUrl,
        ws: saWsApiUrl || wsApiUrl,
        socket: saSocketUrl || socketUrl,
    },
};

export const getBaseUrl = (): IBaseUrl => {
    // @ts-ignore
    if (!process.browser) {
        return baseUrlMap.default;
    }

    // @ts-ignore
    const parts = window?.location?.pathname?.split('/') || [];
    if (parts.length >= 3) {
        const cc = parts[2];
        if (!cc || !baseUrlMap.hasOwnProperty(cc)) {
            return baseUrlMap.default;
        }

        return baseUrlMap[cc];
    }

    return baseUrlMap.default;
};
